import React from 'react';
import { createRoot } from 'react-dom/client';
import CeeSpotTable from './cee-spot-table';

import './table.css';

document.addEventListener('DOMContentLoaded', function () {
	const elements = document.querySelectorAll('.gext-cee-spot-table-container');
	elements.forEach((element) => {
		const dataElement = element.querySelector('.gext-cee-data');
		if (!dataElement) return;

		const data = JSON.parse(dataElement.textContent || '[]');
		const root = createRoot(element);
		root.render(<CeeSpotTable data={data} />);
	});
});
